import { Tooltip } from '@lib/components'
import { Play } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import { clsJoin } from '@/utils'
import css from './styles.module.css'
import { usePublishButton } from './usePublishButton'

interface Props {
  hasShare: boolean
  dividerClassName: string
}

export const PublishButton: React.FC<Props> = ({
  hasShare,
  dividerClassName,
}) => {
  const { isActive, projectIsPublished, handleClick } = usePublishButton()

  return (
    <>
      {hasShare && !isActive && <div className={dividerClassName} />}

      <Tooltip content="Publish">
        <button
          className={clsJoin(
            css.publish_button,
            isActive && css.active,
            !hasShare && css.without_share
          )}
          onClick={handleClick}
        >
          {projectIsPublished && <span className={css.dot} />}
          <Play />
        </button>
      </Tooltip>
    </>
  )
}
